import { registerRootComponent } from "expo";
import App from "./src/App";
import * as serviceWorkerRegistration from "./src/serviceWorkerRegistration";

registerRootComponent(App);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();